var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataLoading)?_c('div',{staticStyle:{"text-align":"center"}},[_c('c-spinner',{attrs:{"ml":"2","color":"orange","thickness":"2px"}}),_c('br'),_c('p',[_vm._v("Coming soon")])],1):_c('div',{staticClass:"pdfContainer",attrs:{"id":"pdfContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }